import {
  HalfStarIcon,
  Link,
  StarFilledIcon,
  Typography,
} from '@iheartjane/reefer';

import styles from './reviewStars.module.css';

type ReviewStarIconsProps = {
  aggregateRating: number;
};

export const ReviewStarIcons = ({ aggregateRating }: ReviewStarIconsProps) => {
  if (aggregateRating % 1 === 0) {
    return (
      <>
        {Array.from({ length: aggregateRating }, (_, ind) => (
          <StarFilledIcon
            size="sm"
            key={`star-${ind}`}
            data-testid={`yellow-star-icon-${ind}`}
          />
        ))}
        {Array.from({ length: 5 - aggregateRating }, (_, ind) => (
          <StarFilledIcon
            color="grays-light"
            size="sm"
            key={`star-${ind}`}
            data-testid={`gray-star-icon-${ind}`}
          />
        ))}
      </>
    );
  } else {
    return (
      <>
        {Array.from({ length: Math.floor(aggregateRating) }, (_, ind) => (
          <StarFilledIcon
            size="sm"
            key={`star-${ind}`}
            data-testid={`yellow-star-icon-${ind}`}
          />
        ))}
        <HalfStarIcon size="sm" data-testid="half-star-icon" />
        {Array.from({ length: 4 - Math.floor(aggregateRating) }, (_, ind) => (
          <StarFilledIcon
            color="grays-light"
            size="sm"
            key={`star-${5 - ind}`}
            data-testid={`gray-star-icon-${ind}`}
          />
        ))}
      </>
    );
  }
};

type ReviewStarsProps = {
  rating: number;
  reviewCount: number;
  scrollToReviews: () => void;
};

export const ReviewStars = ({
  rating,
  reviewCount,
  scrollToReviews,
}: ReviewStarsProps) => (
  <div
    className={styles['pdpReviewStarsContainer']}
    data-testid="pdp-review-star"
  >
    <ReviewStarIcons aggregateRating={rating} />

    <Typography color="text-main" ml={4} mr={16}>
      {rating.toFixed(1)}
    </Typography>

    <Link onClick={() => scrollToReviews()}>
      <Typography color="text-main">{reviewCount} ratings</Typography>
    </Link>
  </div>
);
